import React from 'react'
import { Outlet } from 'react-router-dom';

import Header from "./Header";

function Layout() {
	return (
		<div id="layout-wrapper">
			<Header />
			<div>
				<div className="page-content">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

export default Layout